import React, { useMemo } from 'react';
import { Card, CardMedia, Typography, Link } from '@mui/material';
import Styles from './OverlayCard.module.scss';
import type { OverlayCardProps } from '../../types/cards';
import CloudflareResizedImage from '../CloudflareResizedImage';

const OverlayCard: React.FC<OverlayCardProps> = ({
  showSubtitle = false,
  showCaption = false,
  noOverlay = false,
  carouselRef,
  screenConfig,
  data,
  styles = {},
  trackCardClick = () => {},
}) => {
  const { title, subtitle, caption, link, src } = data;
  const linkAriaLabel = useMemo(() => title || 'Travel Location', [title]);

  return (
    <Card className={Styles.overlayCard} sx={styles}>
      <div
        data-testid="overlay-card"
        className={Styles.overlayCardInner}
        style={{
          // @ts-ignore
          '--sl-overlay-background': `${noOverlay ? 'none' : 'rgba(0,0,0, 0.15)'}`,
        }}
      >
        <Link
          className={Styles.overlayCardLink}
          href={link}
          underline="none"
          onClick={trackCardClick}
          aria-label={`Link to ${linkAriaLabel}`}
        >
          {title && (
            <Typography variant="title1" component="h3" className={Styles.overlayCardTitle}>
              {title}
            </Typography>
          )}
          {subtitle && showSubtitle && (
            <Typography variant="callout2" component="p" className={Styles.overlayCardSubtitle}>
              {subtitle}
            </Typography>
          )}
          {caption && showCaption && (
            <Typography variant="callout2" className={Styles.overlayCardCaption}>
              {caption}
            </Typography>
          )}
        </Link>
        <CardMedia className={Styles.overlayCardImage}>
          <CloudflareResizedImage
            src={src}
            alt={title || 'Travel Location'}
            loading="lazy"
            objectFit="cover"
            objectPosition="center"
            layout="fill"
            lazyRoot={carouselRef}
            quality={95}
            sizes={
              screenConfig
                ? `(min-width: 1024px) ${
                    100 / screenConfig.medium
                  }vw, ((min-width: 769px) and (max-width: 1023px)) calc(${
                    100 / screenConfig.small
                  }vw - 80px), (max-width: 768px) calc(${100 / screenConfig.mobile}vw - 40px)`
                : '(min-width: 1024px) 25vw, ((min-width: 769px) and (max-width: 1023px)) 35vw, (max-width: 768px) 66.6vw'
            }
          />
        </CardMedia>
      </div>
    </Card>
  );
};

export default OverlayCard;
